export default "__VITE_PUBLIC_ASSET__436f1445__"